export default "__VITE_ASSET__aoR_Wv$W__"